import { z } from 'zod';
import { BRAND_CONSTRAINTS } from './constraints.js';
export const updateBrandInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Brand name cannot be empty.')
        .max(BRAND_CONSTRAINTS.name.maxLength, `${BRAND_CONSTRAINTS.name.label} must be ${BRAND_CONSTRAINTS.name.maxLength} characters or fewer`)
        .optional()
        .nullable(),
});
//# sourceMappingURL=update-input.js.map